import { SubscriptionPlan, SubscriptionPlanChargePeriod } from '../models';

export function getMaxAnnualDiscount(subscriptionPlans: SubscriptionPlan[]): number {
	return Math.max(
		...subscriptionPlans
			.filter(subscriptionPlan => subscriptionPlan.hasFlatPrice)
			.map(subscriptionPlan => subscriptionPlan.prices!.get(SubscriptionPlanChargePeriod.annually)!.discount),
	);
}
